// extracted by mini-css-extract-plugin
module.exports = {"createLink":"Subsidiary_createLink__3Y9Pg","link":"Subsidiary_link__QsDN8"};